<template>
  <div>
    <profile-modal-base
      v-if="!showConfirmationModal"
      :is-open="showModal"
      @close="close"
    >
      <template #header>
        <profile-modal-header
          data-test="exam-simulations-modal"
          :header-text="'Exam Simulations'"
          :back-target="'profileShowModal'"
        >
        </profile-modal-header>
      </template>
      <modal-row-group>
        <button
          v-for="sim in resettableSims"
          :key="sim.categoryId"
          class="button-reset flexbox-row button-row"
          @click="handleClick(sim)"
        >
          <span class="text-md font-medium">
            {{ sim.name }}
          </span>
          <span class="flex-1" />
          <span
            v-if="simCategoryStates.has(sim.categoryId)"
            class="text-md font-medium text-error"
          >
            Reset
          </span>
          <span
            v-else
            class="text-md font-medium text-primary"
          >
            Start
          </span>
        </button>
      </modal-row-group>
    </profile-modal-base>
    <confirmation-modal
      v-else
      :confirm-text="'Continue'"
      @close="showConfirmationModal = false"
      @confirm="resetSimProgress"
    >
      <template #header>
        Are you sure?
      </template>
      <div class="text-sm font-regular">
        You will not be able to undo this {{ simToReset.name }} reset. Do you want to continue?
      </div>
    </confirmation-modal>
  </div>
</template>

<script>
import ConfirmationModal from './ConfirmationModal.vue';
import ModalRowGroup from './ModalRowGroup.vue';
import ProfileModalBase from './ProfileModalBase.vue';
import ProfileModalHeader from './ProfileModalHeader.vue';
import ProfileModalMixin from '@/mixins/profileModal';

const MODAL_NAME = 'examSimulationsModal';

export default {
  name: 'ExamSimulationsModal',
  components: {
    ConfirmationModal,
    ModalRowGroup,
    ProfileModalBase,
    ProfileModalHeader,
  },
  mixins: [ProfileModalMixin],
  data() {
    return {
      showConfirmationModal: false,
      simToReset: null,
    };
  },
  computed: {
    showModal() {
      return this.$store.getters['ui/profileModalShown'] === MODAL_NAME;
    },
    simCategoryStates() {
      const states = this.$store.getters['categoryStates/categoryStates'];
      return new Set(
        this.resettableSims.map(sim => states[sim.categoryId]?.categoryId)
          .filter(catId => catId)
      );
    },
  },
  created() {
    this.$store.dispatch('categoryStates/fetchCategoryStates');
  },
  methods: {
    handleClick(sim) {
      if (this.simCategoryStates.has(sim.categoryId)) {
        this.simToReset = sim;
        this.showConfirmationModal = true;
      } else {
        this.close();
        this.$router.push({
          name: 'sims#show',
          params: { simId: sim.categoryId },
        });
      }
    },
    resetSimProgress() {
      if (!this.simToReset) return;
      const category = this.simToReset;
      this.simToReset = null;

      this.showConfirmationModal = false;

      const analyticsParams = {
        simulationName: category?.name,
        simulationId: category.categoryId,
      };

      this.$store.dispatch('simulationConfigs/resetSimulation', { categoryId: category.categoryId }).then(_ => {
        analyticsParams.status = 'Success';
        this.$analytics.events.resetSimProgress(analyticsParams);
        this.$notify({
          group: 'notifications',
          text: 'Simulation reset successfully',
          type: 'success',
        });
        this.$store.commit('flashcardStates/deleteFlashcardStates', { type: 'Category', categoryId: category.categoryId });
        this.$store.commit('categoryStates/deleteCategoryStates', category.categoryId);
      }).catch(e => {
        analyticsParams.status = 'Failure';
        this.$analytics.events.resetSimProgress(analyticsParams);
        this.$notify({
          group: 'notifications',
          text: 'Unable to reset simulation, please contact support',
          type: 'error',
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.button-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: rem-calc(8);
  padding: 0 rem-calc(20);
  height: rem-calc(48);
}
</style>
